import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';

import { CredentialsService } from './credentials.service';

@Injectable({
  providedIn: 'root',
})
export class PermissionsGuard {
  constructor(
    private router: Router,
    private credentialsService: CredentialsService,
  ) {}

  canActivate(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    route: ActivatedRouteSnapshot,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    state: RouterStateSnapshot,
  ): boolean {
    //remove to activate Login
    return true;
    // if (this.credentialsService.isAuthenticated()) {
    //   return this.checkRoutePermissions(route);
    // }

    // return false;
  }

  checkRoutePermissions(route: ActivatedRouteSnapshot) {
    const requiredPermissions = route.data['requiredPermissions'];
    const user = this.credentialsService.credentials;
    if (
      !requiredPermissions ||
      requiredPermissions.length == 0 ||
      user?.is_sysadmin
    ) {
      return true;
    }
    return this.credentialsService.checkPermissions(requiredPermissions);
  }

  hasPermission(currentPermission: number, permission: number) {
    const currentPermissionBin = currentPermission.toString(2);
    const permissionBin = permission.toString(2);
    return (
      currentPermissionBin.charAt(
        currentPermissionBin.length - permissionBin.length,
      ) == permissionBin.charAt(0)
    );
  }
}
